import { DU_CASEFILE_ID_LENGTH } from './AusCasefileIntakeDrawer.constants';

const DU_CASEFILE_ID_PATTERN = new RegExp(`^\\d{${DU_CASEFILE_ID_LENGTH}}$`);

/**
 * DU Casefile ID is optional, but when provided it must be exactly 10 numeric digits.
 *
 * @param {string} value
 * @returns {boolean}
 */
export const isDuCasefileIdValid = value => {
  const trimmed = (value ?? '').trim();

  return !trimmed || DU_CASEFILE_ID_PATTERN.test(trimmed);
};

/**
 * The submit is enabled only when at least one leg has an identifier and no field is invalid.
 *
 * @param {{ duCasefileId: string, lpAusKey: string }} values
 * @returns {boolean}
 */
export const isCasefileIntakeSubmittable = ({ duCasefileId, lpAusKey }) => {
  const trimmedDu = (duCasefileId ?? '').trim();
  const trimmedLp = (lpAusKey ?? '').trim();

  if (!trimmedDu && !trimmedLp) {
    return false;
  }

  return isDuCasefileIdValid(trimmedDu);
};
